import type { GrossProfitSourceFilter } from "@artisancode/api-types";

export const GROSS_PROFIT_SOURCE_LABELS: Record<
  GrossProfitSourceFilter,
  string
> = {
  all: "Semua Sumber",
  sale: "Penjualan Toko",
  rider_sale: "Penjualan Rider",
};
